














































































import { Vue, Component } from "../vue-ext";
import { DefectNotice, HousingCompany, Apartment, EntranceType, User } from "../models";

@Component
export default class DefectNoticeView extends Vue {
    private defectNotice: DefectNotice = {} as DefectNotice;
    private housingCompany: HousingCompany | null = null;
    private apartmentList: Apartment[] | null = null;
    private entranceTypeList: EntranceType[] = [EntranceType.MasterKey, EntranceType.ArrangeWithNotifier];
    private wishedTimeOpen: boolean = false;
    private noticeSentSuccessfully: boolean = false;

    private async created() {
        this.root.setTitle(this.$t("menu.defectNotice") as string);
        this.root.setIconClass("icon-disturbance");

        const housingCompanyId = parseInt(this.$route.params.housingCompanyId, 10);
        const apartmentId = parseInt(this.$route.params.apartmentId, 10);

        if (housingCompanyId) {
            this.defectNotice.housingCompanyId = housingCompanyId;
        }

        if (apartmentId) {
            this.defectNotice.apartmentId = apartmentId;
        }

        this.housingCompany = await this.root.service.housingCompany.Get(housingCompanyId);

        if (!this.housingCompany) {
            this.$router.back();
            return;
        }

        this.apartmentList = await this.root.service.user.GetApartments(this.housingCompany.housingCompanyId);

        const currentUser = this.root.getCurrentUser() as User;

        this.defectNotice.name = currentUser.displayName;
        this.defectNotice.email = currentUser.email;
        this.defectNotice.phone = currentUser.phone;
    }

    private wishedTimeChanged(value: any, type: any) {
        if (type === "minute") {
            this.wishedTimeOpen = false;
        }
    }

    private async save(e: any) {
        e.preventDefault();

        const res = await this.root.service.notice.SendDefectNotice(this.defectNotice);

        if (!res.isError) {
            this.noticeSentSuccessfully = true;
        }
    }
}
